export default __webpack_public_path__ + "static/media/Tesla-logo.2c275148.svg";